import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/SKS_Logo_Negativ_RGB.png'


const _withScopeId = n => (_pushScopeId("data-v-5f11bf2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#main-content",
  class: "skip-to-content"
}, "Skip to main content", -1))
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Original Logo",
  class: "logo original-logo"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bottom" }, "Museernes Samlinger", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "menu-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-text-top" }, "Museernes", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-text-bottom" }, "Samlinger", -1))
const _hoisted_10 = ["aria-label", "aria-expanded"]

import { BREAKPOINTS, useViewport } from "@slks/core";
import { onBeforeUnmount } from "vue";
import { onMounted } from "vue";
import { ref } from "vue";
import NavMenu from "./NavMenu.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainHeader',
  setup(__props) {

const mainHeader = ref<HTMLElement | null>(null);
const menuOpened = ref<boolean>(false);

const { matches: isDesktop } = useViewport(BREAKPOINTS.desktop);

const clearDisplayMode = () => {
    localStorage.removeItem("search_display_mode");
};

const toggleMenu = () => {
    menuOpened.value = !menuOpened.value;
    document.getElementById("home-menu").focus();
};

const handleScroll = () => {
    if (!mainHeader.value) return;
    const headerElement = mainHeader.value;

    if (window.scrollY > 50) {
        headerElement.classList.add("scrolled");
    } else {
        headerElement.classList.remove("scrolled");
    }
};

const handleResize = () => {
    if (!mainHeader.value) return;
    const headerElement = mainHeader.value;

    if (isDesktop.value) {
        headerElement.classList.remove("mobile");
    } else {
        headerElement.classList.add("mobile");
    }
};

onMounted(() => {
    handleResize();
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
});
onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("resize", handleResize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    id: "main-header",
    ref_key: "mainHeader",
    ref: mainHeader
  }, [
    _hoisted_1,
    _createVNode(NavMenu, {
      opened: menuOpened.value,
      onChange: _cache[0] || (_cache[0] = (val) => (menuOpened.value = val))
    }, null, 8, ["opened"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "logo-container" }, [
        _createElementVNode("a", {
          href: "/",
          "aria-label": "Home",
          onClick: clearDisplayMode
        }, _hoisted_4),
        _createElementVNode("a", {
          href: "/",
          class: "alternative-logo",
          "aria-label": "Museernes Samlinger Home",
          onClick: clearDisplayMode
        }, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("button", {
          class: "burger-menu",
          onClick: toggleMenu,
          "aria-label": menuOpened.value ? 'Close menu' : 'Open menu',
          "aria-expanded": menuOpened.value.toString()
        }, " ☰ ", 8, _hoisted_10)
      ])
    ])
  ], 512))
}
}

})